module.exports = __webpack_public_path__ + "img/hench.5bfed041.png";